<template>
  <div>
    <changeorder-list v-show="tabType === 1" @handleShow="handleShow" />
    <changeorder-show v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow"  />
  </div>
</template>

<script>
import changeorderList from './list.vue'
import changeorderShow from './show.vue'
export default {
  components: { changeorderList, changeorderShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>